import type { LayoutConfig, PlanServiceItem } from '@/utils/dealCalculations'
import { defaultLayoutConfig, groupServicesByCategory } from '@/utils/dealCalculations'
import { computeCategoryBlocksPercent, type CategoryBlockPercent } from '@/utils/pptxSlideCategoryLayout'
import { formatServiceLineLabel } from '@/utils/text-normalization'
function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function renderCategoryBlock(block: CategoryBlockPercent): string {
  const itemsHtml = block.items
    .map(
      (s) => `
          <div class="service-item">
            <span class="service-icon">
              <svg class="service-svg" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 13l4 4L19 7" fill="none" stroke="#72C063" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <div class="service-content">
              <span class="service-name">${escapeHtml(formatServiceLineLabel(s.nome, s.quantity))}</span>
              ${s.description ? `<div class="service-detail">${escapeHtml(s.description)}</div>` : ''}
            </div>
          </div>`,
    )
    .join('')

  return `
      <div class="category-block">
        <div class="section-title">${escapeHtml(block.categoria)}</div>
        ${itemsHtml}
      </div>`
}

/** Colunas alinhadas ao layout do Studio (coords X: esquerda vs direita). */
export function buildAnnexServicesColumnsHtml(
  servicos: PlanServiceItem[],
  layoutConfig?: LayoutConfig,
): string {
  const layout = { ...defaultLayoutConfig, ...(layoutConfig || {}) }
  const groups = groupServicesByCategory(servicos)
  const blocks = computeCategoryBlocksPercent(layout, groups, layout.leftBlockWidth || 35)

  const col1X = layout.serviceBlockX || 38
  const col2X = layout.serviceBlockGap || 68
  const midpoint = (col1X + col2X) / 2

  const leftBlocks = blocks.filter((b) => b.x < midpoint).sort((a, b) => a.y - b.y)
  const rightBlocks = blocks.filter((b) => b.x >= midpoint).sort((a, b) => a.y - b.y)

  return `
      <div class="services-grid">
        <div class="services-col">${leftBlocks.map(renderCategoryBlock).join('')}</div>
        <div class="services-col">${rightBlocks.map(renderCategoryBlock).join('')}</div>
      </div>`
}
